/**
 * Presentation-only helpers for patient names. Does not mutate API or stored data.
 */

/**
 * @param {string|null|undefined} name
 * @param {string} [emptyFallback=''] Returned when name is null, undefined, or blank after trim
 * @returns {string}
 */
export function displayPatientName(name, emptyFallback = "") {
  if (name == null) return emptyFallback;
  const s = String(name).trim();
  if (!s) return emptyFallback;
  return s.toUpperCase();
}

/**
 * Builds an uppercase display string from full name, or from split name fields when name is absent.
 *
 * @param {object|null|undefined} patient
 * @param {string} [emptyFallback='']
 * @returns {string}
 */
export function displayPatientNameFromParts(patient, emptyFallback = "") {
  if (!patient) return emptyFallback;
  const { first_name, middle_name, last_name, name } = patient;
  if (name != null && String(name).trim() !== "") {
    return displayPatientName(name, emptyFallback);
  }
  if (first_name !== null && first_name !== undefined && String(first_name).trim() !== "") {
    let nameString = String(first_name).trim();
    if (middle_name != null && String(middle_name).trim() !== "") {
      nameString += ` ${String(middle_name).trim()}`;
    }
    if (last_name != null && String(last_name).trim() !== "") {
      nameString += ` ${String(last_name).trim()}`;
    }
    return displayPatientName(nameString);
  }
  return emptyFallback;
}
